import React, { useContext } from 'react'

import { StrokeOptions } from 'perfect-freehand'
import { createMemoryRouter } from 'react-router-dom'

import {
  CardStudioState,
  DEFAULT_DEVTOOLS_SETTINGS,
  DevToolsSettings,
  INITIAL_CARD_STUDIO_STATE,
  ToolKey,
} from './reducers'

export type InitCardStudioDevToolsArgs = {
  context: CanvasRenderingContext2D
  metrics: {
    buffer: { x: number; y: number }
    ratio: { x: number; y: number }
    scale: { x: number; y: number }
    translation: { x: number; y: number }
  }
  strokeOptions: StrokeOptions
}

export type DevToolsContextState = {
  settings: DevToolsSettings
  toggle: (key: ToolKey) => void
  cardStudio: CardStudioState & {
    initDevTools: (args: InitCardStudioDevToolsArgs) => void
    updateDevToolsImageData: (imageData: string) => void
    toggleOption: (key: 'showGrid' | 'showCoordinates') => void
    strokeOptions: StrokeOptions
    setStrokeOptions: (options: StrokeOptions) => void
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    performance: any // set to any to avoid circular dependency
    withPerformanceMetrics: (callback: () => void, canvasName: string) => void
    shouldCreatePreview: boolean
    togglePreview: (value: boolean) => void
  }
  journeyRouter?: ReturnType<typeof createMemoryRouter> | null
}

const toggle: (key: ToolKey) => void = () => {
  return
}
const initDevTools: (args: InitCardStudioDevToolsArgs) => void = () => {
  return
}
const updateDevToolsImageData: (imageData: string) => void = () => {
  return
}
const toggleOption: (key: 'showGrid' | 'showCoordinates') => void = () => {
  return
}
const setStrokeOptions: (options: StrokeOptions) => void = () => {
  return
}
const withPerformanceMetrics = (callback: () => void) => {
  callback()
}
const togglePreview = (value: boolean) => {
  return
}

export const DevToolsContext = React.createContext<DevToolsContextState>({
  settings: DEFAULT_DEVTOOLS_SETTINGS,
  toggle,
  cardStudio: {
    ...INITIAL_CARD_STUDIO_STATE,
    initDevTools,
    updateDevToolsImageData,
    toggleOption,
    setStrokeOptions,
    performance: undefined,
    withPerformanceMetrics,
    shouldCreatePreview: false,
    togglePreview,
  },
  journeyRouter: null,
})

export const useDevToolsSettings = () => useContext(DevToolsContext).settings
export const useCardStudioDevTools = () => useContext(DevToolsContext).cardStudio
export const useJourneyDevTools = () => useContext(DevToolsContext).journeyRouter
